import { Button, Modal, Space, Typography } from 'antd';
import React, { useState } from 'react';

import type CommunityGroups from '@/types/database/communityGroups';

import styles from './index.module.scss';

interface CheckDetailModalProps {
  record: CommunityGroups;
}

const { Text } = Typography;

const CheckDetailModal = ({ record }: CheckDetailModalProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const showDetail = () => {
    setIsOpenModal(true);
  };

  return (
    <>
      <Button onClick={() => showDetail()}>查看</Button>
      <Modal
        open={isOpenModal}
        footer={null}
        title="社區住戶資料"
        centered
        destroyOnClose
        onCancel={() => setIsOpenModal(false)}
      >
        <Space direction="vertical" className={styles.widthFull}>
          <div>
            <Text type="secondary">社區名稱</Text>
            <p>{record.name}</p>
          </div>
          <div>
            <Text type="secondary">戶號</Text>
            <p>{record.householdNumbers.join('、')}</p>
          </div>
          <div className={styles.closeModalButton}>
            <Button onClick={() => setIsOpenModal(false)}>確認</Button>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export default CheckDetailModal;
